/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataPointHistory } from './DataPointHistory';
import {
    DataPointHistoryFromJSON,
    DataPointHistoryFromJSONTyped,
    DataPointHistoryToJSON,
    DataPointHistoryToJSONTyped,
} from './DataPointHistory';
import type { DataSourceEnum } from './DataSourceEnum';
import {
    DataSourceEnumFromJSON,
    DataSourceEnumFromJSONTyped,
    DataSourceEnumToJSON,
    DataSourceEnumToJSONTyped,
} from './DataSourceEnum';
import type { DataPointHistoryLocation } from './DataPointHistoryLocation';
import {
    DataPointHistoryLocationFromJSON,
    DataPointHistoryLocationFromJSONTyped,
    DataPointHistoryLocationToJSON,
    DataPointHistoryLocationToJSONTyped,
} from './DataPointHistoryLocation';

/**
 * Serializer to represent an unmatched `DataPoint` along with the decision
 * taken for it, if any.
 * @export
 * @interface UnmatchedDataPoint
 */
export interface UnmatchedDataPoint {
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPoint
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPoint
     */
    dataBatch: string;
    /**
     * 
     * @type {DataSourceEnum}
     * @memberof UnmatchedDataPoint
     */
    readonly dataSource: DataSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPoint
     */
    plumeImage?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnmatchedDataPoint
     */
    emissionDetected?: boolean;
    /**
     * Rate of emission detected (g/hr)
     * @type {number}
     * @memberof UnmatchedDataPoint
     */
    detectedRate?: number | null;
    /**
     * Uncertainty of emission detected rate (g/hr)
     * @type {number}
     * @memberof UnmatchedDataPoint
     */
    detectedRateUncertainty?: number | null;
    /**
     * Detection limit (g/hr)
     * @type {number}
     * @memberof UnmatchedDataPoint
     */
    detectionLimit: number;
    /**
     * Concentration of the emission (ppm)
     * @type {number}
     * @memberof UnmatchedDataPoint
     */
    concentration?: number | null;
    /**
     * Uncertainty of emission concentration value (ppm)
     * @type {number}
     * @memberof UnmatchedDataPoint
     */
    concentrationUncertainty?: number | null;
    /**
     * 
     * @type {DataPointHistoryLocation}
     * @memberof UnmatchedDataPoint
     */
    location: DataPointHistoryLocation;
    /**
     * 
     * @type {any}
     * @memberof UnmatchedDataPoint
     */
    data?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof UnmatchedDataPoint
     */
    detectionTimestamp: Date;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPoint
     */
    readonly providerName: string;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPoint
     */
    secondaryDataSource?: string;
    /**
     * 
     * @type {Date}
     * @memberof UnmatchedDataPoint
     */
    readonly createdAt: Date | null;
    /**
     * 
     * @type {Array<DataPointHistory>}
     * @memberof UnmatchedDataPoint
     */
    readonly history: Array<DataPointHistory>;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPoint
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPoint
     */
    readonly decision: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPoint
     */
    readonly decisionSite: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPoint
     */
    readonly decisionTakenBy: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UnmatchedDataPoint
     */
    readonly decisionTakenAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPoint
     */
    readonly notes: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPoint
     */
    readonly emissionRecordId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UnmatchedDataPoint
     */
    readonly decisionProcessedAt: Date | null;
    /**
     * Returns the presets containing this data point, limited to the ones
     * the user can access.
     * @type {Array<number>}
     * @memberof UnmatchedDataPoint
     */
    readonly presetIds: Array<number>;
}



/**
 * Check if a given object implements the UnmatchedDataPoint interface.
 */
export function instanceOfUnmatchedDataPoint(value: object): value is UnmatchedDataPoint {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('dataBatch' in (value as Record<string, any>)) && !('data_batch' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataBatch'] === undefined && (value as Record<string, any>)['data_batch'] === undefined)) return false;
    if ((!('dataSource' in (value as Record<string, any>)) && !('data_source' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataSource'] === undefined && (value as Record<string, any>)['data_source'] === undefined)) return false;
    if ((!('detectionLimit' in (value as Record<string, any>)) && !('detection_limit' in (value as Record<string, any>))) || ((value as Record<string, any>)['detectionLimit'] === undefined && (value as Record<string, any>)['detection_limit'] === undefined)) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if ((!('detectionTimestamp' in (value as Record<string, any>)) && !('detection_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['detectionTimestamp'] === undefined && (value as Record<string, any>)['detection_timestamp'] === undefined)) return false;
    if ((!('providerName' in (value as Record<string, any>)) && !('provider_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['providerName'] === undefined && (value as Record<string, any>)['provider_name'] === undefined)) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    if (!('history' in value) || value['history'] === undefined) return false;
    if (!('decision' in value) || value['decision'] === undefined) return false;
    if ((!('decisionSite' in (value as Record<string, any>)) && !('decision_site' in (value as Record<string, any>))) || ((value as Record<string, any>)['decisionSite'] === undefined && (value as Record<string, any>)['decision_site'] === undefined)) return false;
    if ((!('decisionTakenBy' in (value as Record<string, any>)) && !('decision_taken_by' in (value as Record<string, any>))) || ((value as Record<string, any>)['decisionTakenBy'] === undefined && (value as Record<string, any>)['decision_taken_by'] === undefined)) return false;
    if ((!('decisionTakenAt' in (value as Record<string, any>)) && !('decision_taken_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['decisionTakenAt'] === undefined && (value as Record<string, any>)['decision_taken_at'] === undefined)) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if ((!('emissionRecordId' in (value as Record<string, any>)) && !('emission_record_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionRecordId'] === undefined && (value as Record<string, any>)['emission_record_id'] === undefined)) return false;
    if ((!('decisionProcessedAt' in (value as Record<string, any>)) && !('decision_processed_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['decisionProcessedAt'] === undefined && (value as Record<string, any>)['decision_processed_at'] === undefined)) return false;
    if ((!('presetIds' in (value as Record<string, any>)) && !('preset_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['presetIds'] === undefined && (value as Record<string, any>)['preset_ids'] === undefined)) return false;
    return true;
}

export function UnmatchedDataPointFromJSON(json: any): UnmatchedDataPoint {
    return UnmatchedDataPointFromJSONTyped(json, false);
}

export function UnmatchedDataPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnmatchedDataPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataBatch': json['data_batch'],
        'dataSource': DataSourceEnumFromJSON(json['data_source']),
        'plumeImage': json['plume_image'] === undefined ? undefined : json['plume_image'] === null ? null : json['plume_image'],
        'emissionDetected': json['emission_detected'] == null ? undefined : json['emission_detected'],
        'detectedRate': json['detected_rate'] === undefined ? undefined : json['detected_rate'] === null ? null : json['detected_rate'],
        'detectedRateUncertainty': json['detected_rate_uncertainty'] === undefined ? undefined : json['detected_rate_uncertainty'] === null ? null : json['detected_rate_uncertainty'],
        'detectionLimit': json['detection_limit'],
        'concentration': json['concentration'] === undefined ? undefined : json['concentration'] === null ? null : json['concentration'],
        'concentrationUncertainty': json['concentration_uncertainty'] === undefined ? undefined : json['concentration_uncertainty'] === null ? null : json['concentration_uncertainty'],
        'location': DataPointHistoryLocationFromJSON(json['location']),
        'data': json['data'] === undefined ? undefined : json['data'] === null ? null : json['data'],
        'detectionTimestamp': (new Date(json['detection_timestamp'])),
        'providerName': json['provider_name'],
        'secondaryDataSource': json['secondary_data_source'] == null ? undefined : json['secondary_data_source'],
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
        'history': ((json['history'] as Array<any>).map(DataPointHistoryFromJSON)),
        'version': json['version'] == null ? undefined : json['version'],
        'decision': json['decision'],
        'decisionSite': json['decision_site'],
        'decisionTakenBy': json['decision_taken_by'],
        'decisionTakenAt': (json['decision_taken_at'] == null ? null : new Date(json['decision_taken_at'])),
        'notes': json['notes'],
        'emissionRecordId': json['emission_record_id'],
        'decisionProcessedAt': (json['decision_processed_at'] == null ? null : new Date(json['decision_processed_at'])),
        'presetIds': json['preset_ids'],
    };
}

export function UnmatchedDataPointToJSON(json: any): UnmatchedDataPoint {
    return UnmatchedDataPointToJSONTyped(json, false);
}

export function UnmatchedDataPointToJSONTyped(value?: Omit<UnmatchedDataPoint, 'id'|'dataSource'|'providerName'|'createdAt'|'history'|'decision'|'decisionSite'|'decisionTakenBy'|'decisionTakenAt'|'notes'|'emissionRecordId'|'decisionProcessedAt'|'presetIds'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data_batch': value['dataBatch'],
        'plume_image': value['plumeImage'],
        'emission_detected': value['emissionDetected'],
        'detected_rate': value['detectedRate'],
        'detected_rate_uncertainty': value['detectedRateUncertainty'],
        'detection_limit': value['detectionLimit'],
        'concentration': value['concentration'],
        'concentration_uncertainty': value['concentrationUncertainty'],
        'location': DataPointHistoryLocationToJSON(value['location']),
        'data': value['data'],
        'detection_timestamp': value['detectionTimestamp'].toISOString(),
        'secondary_data_source': value['secondaryDataSource'],
        'version': value['version'],
    };
}

